import { __extends } from 'tslib';
import classNames from 'classnames';
import * as React from 'react';
import styles from './Count.module.scss.js';

var Count = (function (_super) {
    __extends(Count, _super);
    function Count() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.increase = function () {
            var val = _this.props.value + 1;
            if (_this.props.max && val > _this.props.max) {
                val = _this.props.max;
            }
            _this.props.onChange(val);
        };
        _this.decrease = function () {
            var val = _this.props.value - 1;
            if (_this.props.min) {
                if (val < _this.props.min) {
                    val = _this.props.min;
                }
            }
            else {
                if (val < 0) {
                    val = 0;
                }
            }
            _this.props.onChange(val);
        };
        return _this;
    }
    Count.prototype.render = function () {
        var increaseDisable = this.props.max && this.props.max === this.props.value;
        var decreaseDisable = this.props.min && this.props.min === this.props.value;
        return (React.createElement("div", { className: classNames(styles.wrapper, this.props.className) },
            React.createElement("div", { className: styles.arrowLeft + " " + (decreaseDisable ? styles.disabled : ''), onClick: this.decrease }),
            React.createElement("div", { className: styles.value }, this.props.value),
            React.createElement("div", { className: styles.arrowRight + " " + (increaseDisable ? styles.disabled : ''), onClick: this.increase })));
    };
    return Count;
}(React.PureComponent));

export { Count as default };
//# sourceMappingURL=Count.js.map
